import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import MediaSection from '@/pages/home/components/MediaSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import ContactSection from '@/pages/home/components/ContactSection';
import RankingSection from '@/pages/home/components/RankingSection';
import AppSection from '@/pages/home/components/AppSection';
import CardsSection from '@/pages/home/components/CardsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import AboutSection from '@/pages/home/components/AboutSection';
import FaqSection from '@/pages/home/components/FaqSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <UpdatesSection />

        <MediaSection />

        <CarouselSection />

        <TopicsSection />

        <ContactSection />

        <RankingSection />

        <AppSection />

        <CardsSection />

        <IndexSection />

        <FeaturesSection />

        <CommentsSection />

        <AboutSection />

        <FaqSection />
      </main>

      <Footer />
    </div>
  );
}